import { StateUtils } from '@spartacus/core';
import { ACCEPT_MANAGER } from '../my-account-state';

export const APPROVE_PERSONAL_MANAGER = '[My Account] Approve Manager';
export const APPROVE_PERSONAL_MANAGER_SUCCESS = '[My Account] Approve Manager Success';
export const APPROVE_PERSONAL_MANAGER_FAIL = '[My Account] Approve Manager Fail';

export class ApprovePersonalManager extends StateUtils.EntityLoadAction {
  readonly type = APPROVE_PERSONAL_MANAGER;

  constructor(public payload: string) {
    super(ACCEPT_MANAGER, payload);
  }
}

export class ApprovePersonalManagerSuccess extends StateUtils.EntitySuccessAction {
  readonly type = APPROVE_PERSONAL_MANAGER_SUCCESS;

  constructor(public personalManagerId: string) {
    super(ACCEPT_MANAGER, personalManagerId);
  }
}
export class ApprovePersonalManagerFail extends StateUtils.EntityFailAction {
  readonly type = APPROVE_PERSONAL_MANAGER_FAIL;

  constructor(
    public personalManagerId: string,
    public error: unknown,
  ) {
    super(ACCEPT_MANAGER, personalManagerId);
  }
}
